{
  "CHAT_LIST": {
    "LOADING": "Gesprekken ophalen",
    "LOAD_MORE_CONVERSATIONS": "Meer gesprekken laden",
    "EOF": "Alle gesprekken geladen 🎉",
    "LIST": {
      "404": "Er zijn geen actieve gesprekken in deze groep."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Gesprekken",
    "MENTION_HEADING": "Vermeldingen",
    "UNATTENDED_HEADING": "Onbeheer",
    "SEARCH": {
      "INPUT": "Zoek naar mensen, gesprekken, opgeslagen antwoorden .."
    },
    "SEARCH_MESSAGES": "Gesprekken zoeken",
    "SEARCH_INPUT_PLACEHOLDER": "Gesprekken zoeken...",
    "FILTER_ALL": "Allemaal",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Mijn",
      "unassigned": "Niet toegewezen",
      "all": "Allemaal"
    },
    "MESSAGE_USE_AS_TEMPLATE": "In antwoord plakken",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Openen",
        "BUY": "Kopen"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Open"
      },
      "resolved": {
        "TEXT": "Opgelost"
      },
      "pending": {
        "TEXT": "Afwachtend"
      },
      "snoozed": {
        "TEXT": "Gesluimerd"
      },
      "all": {
        "TEXT": "Allemaal"
      }
    },
    "VIEW_FILTER": "Bekijken",
    "SORT_TOOLTIP_LABEL": "Sorteer gesprekken",
    "CHAT_SORT": {
      "STATUS": "Status",
      "ORDER_BY": "Sorteren op"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Aangemaakt op",
      "LAST_ACTIVITY": "Laatste Activiteit:",
      "LAST_CUSTOMER_MESSAGE": "Laatste bericht van klant:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Laatste bericht van klant: Oudste eerst"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Laatste bericht van klant: Nieuwste eerst"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "priority_created_at_desc": {
        "TEXT": "Prioriteit + Aangemaakt op: Nieuwste eerst"
      },
      "priority_created_at_asc": {
        "TEXT": "Prioriteit + Aangemaakt op: Oudste eerst"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Bericht met foto"
      },
      "audio": {
        "CONTENT": "Audiobericht"
      },
      "video": {
        "CONTENT": "Videobericht"
      },
      "file": {
        "CONTENT": "Bestandsbijlage"
      },
      "location": {
        "CONTENT": "Locatie"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "heeft een url gedeeld"
      },
      "contact": {
        "CONTENT": "Shared contact"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Gesprek sorteren",
      "DROPDOWN_TITLE": "Sorteren op",
      "ITEMS": {
        "LATEST": {
          "NAME": "Laatste activiteit om",
          "LABEL": "Laatste Activiteit"
        },
        "CREATED_AT": {
          "NAME": "Aangemaakt op",
          "LABEL": "Aangemaakt op"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Laatste bericht van gebruiker op",
          "LABEL": "Laatste bericht"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Ontvangen via e-mail",
    "VIEW_TWEET_IN_TWITTER": "Bekijk tweet op Twitter",
    "REPLY_TO_TWEET": "Antwoord op deze tweet",
    "LINK_TO_STORY": "Ga naar instagram verhaal",
    "SENT": "Succesvol verzonden",
    "READ": "Succesvol gelezen",
    "DELIVERED": "Succesvol afgeleverd",
    "NO_MESSAGES": "Geen berichten",
    "NO_CONTENT": "Geen inhoud beschikbaar",
    "HIDE_QUOTED_TEXT": "Verberg geciteerde tekst",
    "SHOW_QUOTED_TEXT": "Toon geciteerde tekst",
    "HIDE_AUTOMATED_MESSAGE": "Inhoud automatisch antwoord verbergen",
    "SHOW_AUTOMATED_MESSAGE": "Inhoud automatisch antwoord tonen",
    "AUTOMATED_MESSAGE": "Automatisch antwoord",
    "MESSAGE_READ": "Lezen",
    "SENDING": "Sending"
  }
}
